import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";

window.addEventListener('unhandledrejection', (event) => {
  const reason = event?.reason;
  if (reason?.name === 'AbortError') {
    event.preventDefault();
  }
});

const container = document.getElementById("root");
const root = createRoot(container);

root.render(<App />);
